import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const WindDust = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const dust = Array.from({ length: 100 }).map(() => ({
      id: Math.random(),
      startX: 0 + Math.random() * 150,
      startY: 0 + Math.random() * 150,
      duration: 4 + Math.random() * 8,
      length: 30 + Math.random() * 70,
      thickness: 1 + Math.random() * 3,
      opacity: 0.1 + Math.random() * 0.2,
      blur: Math.random() > 0.5 ? "blur-[1px]" : "blur-[2px]",
    }));
    setParticles(dust);
  }, []);

  return (
    <div className="absolute inset-0 z-[2] pointer-events-none overflow-hidden">
      {particles.map((p) => (
        <motion.div
          key={p.id}
          className={`absolute bg-[#f4ecd8] rounded-full ${p.blur}`}
          style={{
            width: `${p.length}px`,
            height: `${p.thickness}px`,
            left: `${p.startX}vw`,
            top: `${p.startY}vh`,
            rotate: 45,
          }}
          initial={{ opacity: 0 }}
          animate={{
            x: ["0vw", "-150vw"],
            y: ["0vh", "-150vh"],
            opacity: [0, p.opacity, p.opacity, 0],
          }}
          transition={{
            duration: p.duration,
            repeat: Infinity,
            ease: "linear",
          }}
        />
      ))}
    </div>
  );
};

export default WindDust